module.exports = __webpack_public_path__ + "img/8.48ed94e1.png";